import cuid from "cuid";

export const STORYBOARD = [
	{
		id: cuid(),
		idStoryboard: cuid(),
		content:
			"Kia Orana! Je m'appelle JL AI et je t'offre une lecture Numérologique.",
		role: "bot",
		reply: null,
	},
	{
		id: cuid(),
		idStoryboard: cuid(),
		content: "Avant de commencer, comment t'appelles-tu ?",
		role: "bot",
		reply: {
			format: "text",
			placeholder: "Je m'appelle...",
			key: "firstName",
		},
	},
	{
		id: cuid(),
		idStoryboard: cuid(),
		content:
			"Enchanté de faire ta connaissance ! Maintenant, j'ai besoin de connaître ta date de naissance. Ce sont les nombres de ta naissance qui vont me permettre de faire la lecture",
		role: "bot",
		reply: {
			format: "birthday",
			key: "birthday",
		},
	},
	{
		id: cuid(),
		idStoryboard: cuid(),
		content: "Es-tu une femme ou un homme ?",
		role: "bot",
		reply: {
			format: "gender",
			key: "gender",
		},
	},
	{
		id: cuid(),
		idStoryboard: cuid(),
		content: "Avant de poursuivre, donne-moi ton adresse email.",
		role: "bot",
		reply: {
			format: "email",
			placeholder: "Entrez votre email...",
			key: "email",
		},
	},
	{
		id: cuid(),
		idStoryboard: cuid(),
		content:
			"Super ! J'ai tout ce qu'il me faut... Clique sur le bouton pour démarrer !",
		role: "bot",
		reply: {
			format: "button",
			content: "Démarrer Ma Lecture",
			action: "success",
		},
	},
];

export const CHATBOT_THEME = {
	container: {
		width: "100%",
		maxWidth: "1000px",
		height: "400px",
		padding: "20px",
		paddingBottom: "10px",
		overflow: "scroll",
		display: "flex",
		margin: "0 auto",
		flexDirection: "column",
		backgroundColor: "#120f18",
	},
	messages: {
		flexGrow: 1,
		overflowX: "hidden",
		overflowY: "scroll",
		height: "80vh",
		maxWidth: "1014px",
		borderRadius: "25px",
	},
	inputBar: {
		display: "flex",
		alignItems: "center",
	},
	welcomeText: {
		textAlign: "center",
		marginBottom: "10px",
		color: "#ffffff",
	},
	avatar: {
		width: "40px",
		height: "40px",
		borderRadius: "50%",
	},
};
